import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { bindActionCreators } from "redux";
import { Route, Link, withRouter } from 'react-router-dom';
import { PublishedItem } from './PublishedItem';

@withRouter
export class PublicationGroup extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = { showDetail: false };
        this.onToggleClicked = this.onToggleClicked.bind(this);
    }

    componentDidMount() {
        let hash = this.props.location.hash;
        if (this.props.location.pathname.toLowerCase().indexOf(this.props.groupType.toLowerCase()) > -1) {
            this.setState({ showDetail: true });
        } else if (hash) {
             /*else if (this.props.data) {
                // should the section be expanded
                let filteredData = this.props.data.filter((item, index) => item.type === this.props.groupTypeId);
                let containsAnchor = filteredData.filter(f => f.anchor == findHash).length > 0;
                this.setState({ showDetail: containsAnchor });
            }*/
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname != this.props.location.pathname) {
            if (this.props.location.pathname.toLowerCase().indexOf(this.props.groupType.toLowerCase()) > -1) {
                this.setState({ showDetail: true });
            } else {
                this.setState({ showDetail: false });
            }
        }
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail });
    }

    render() {
        const { location, children, groupType, groupTypeId, data, ...props } = this.props;


        let toggleCss = this.state.showDetail ? "fa fa-minus fa-lg text-right " : "fa fa-plus fa-lg text-right ";
        let filteredData = data.filter((item, index) => item.type === groupTypeId);
        let publications = filteredData.map((item, index) => { return <PublishedItem key={"publishedItem" + index} idx={index} {...item}></PublishedItem>; });

        let detail = this.state.showDetail ? publications : undefined;
        return (
            <div className="mb-3" >
                <div className="row base1-bg clickable" onClick={this.onToggleClicked}>
                    <div className="col col-10 mb-3 mt-3 ">
                        <h5>{groupType} ({filteredData.length})</h5>
                    </div>
                    <div className="col col-2 mb-3 mt-3">
                        <span onClick={this.onToggleClicked} className={toggleCss} ></span>
                    </div>
                </div>
                {detail}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Publications/PublicationGroup.tsx